import React, { useEffect, useState } from "react";
import "./Homepage.css";
import HomepageHeader from "./HomepageHeader";
import DashboardHeader from "./DashboardHeader";
import FooterHome from "./FooterHome";
import FooterHomeStripe from "./FooterHomeStripe";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Cookies from "universal-cookie";
import ProfessionalHeader from "../Professionals/ProfessionalHeader";
import { DecodingString } from "../helperFunction/DecodingString";
import expert from "../pages/images/wellnessexpertimg.svg";
import closequote from "../pages/images/closedoublequotes.svg";
import openquote from "../pages/images/opendoublequotes.svg";
import DashboardExploreCards from "./Reusable cards/DashboardExploreCards";
import back from "../recommended activites/images/vector2Gem.svg";
import { useNavigate } from 'react-router-dom';

const ContactUs = () => {
  const [tutorials, setTutorials] = useState([]);
  const navigate = useNavigate();
  const Psychotherapy = [
    {
      id: 1,
      question: "Do I need to talk to a mental health professional?",
      answer:
        "Talking to a mental wellness professional about your mental health issues or emotional difficulties is a positive step towards improving your mental health. They aim to provide you with a non-judgemental and safe environment to develop support, problem solving skills and coping strategies for a wide range of concerns.",
    },
    {
      id: 2,
      question: "How exactly would therapy benefit me?",
      answer:
        "There are several benefits of therapy. Some of them include improving communication skills, developing coping abilities, boosting self confidence amongst others while attaining a better understanding of yourself, changing old patterns, and developing new ones. A mental health professional would help you to better understand and manage emotions such as sadness, anger, guilt etc.",
    },
    {
      id: 3,
      question: "What sorts of issues can therapy help with?",
      answer:
        "Mental Wellness professionals at Bit Happier are professionally trained to deal with mental health difficulties such as depression, anxiety, personality problems, etc. Moreover, they work towards managing relationship concerns, workplace and academic difficulties, adjustment concerns, problems related to lifestyles, family conflict, parental guidance, anger management, time management and communication skills.",
    },
    {
      id: 4,
      question:
        "What will happen during my initial session, I'm a bit anxious about it?",
      answer:
        "The initial session involves discussing the client’s history and needs for treatment. During this first session the client will have the opportunity to see how therapy will work, review office policies, privacy and confidentiality, as well as determine whether or not they are comfortable with the therapist.",
    },
    {
      id: 5,
      question: "What if I am not satisfied with my therapist?",
      answer:
        "All therapists at Bit Happier are trained to professionally manage client’s with emotional and mental health difficulties. However, if you are not satisfied with your expert, please write to us at contact@Bithappier.com describing the concern and we will get back to you. ",
    },
    {
      id: 6,
      question: "How many sessions are needed?",
      answer:
        "Therapy is most impactful when it is conducted weekly. However, the number of sessions to be conducted depend upon your need which can be discussed with your therapist who will provide their professional recommendations after which you are free to make the decision yourself.",
    },
    {
      id: 7,
      question: "Are there trial sessions available?",
      answer: "Trial counselling sessions are not provided at Bit Happier.",
    },
    {
      id: 8,
      question: "Do I need to prepare for the first session?",
      answer:
        "Please do ensure you have a private and comfortable space for counselling along with some points you wish to be discussed. However, there are no prerequisite compulsions!",
    },
    {
      id: 9,
      question: "How is the payment done?",
      answer: "Advanced payment may be done through NEAR crypto wallet.",
    },
    {
      id: 10,
      question: "What if I wish to cancel or reschedule my sessions?",
      answer:
        "Counselling sessions at Bit Happier can be cancelled or rescheduled within 24 hours in advance. If unable to attend the session, you may be asked to give 50% of the fee, as the counsellor is unable to use this time slot for any other client. If you are unable to reschedule within the expected time period, please send an email to contact@bithappier.com citing your reasons.",
    },
    {
      id: 11,
      question: "Can I call my counsellor in emergency situations?",
      answer:
        "It is important to remember that counsellors at Bit Happier are not crisis counsellors and cannot communicate with you outside of sessions. This is to ensure that dependency on the counsellor is not developed and professional boundaries are maintained.You can have a look at the crisis helpline numbers on our website.",
    },
    {
      id: 12,
      question: "Is online therapy the right option for me?",
      answer:
        "Online therapy adopts a range of techniques wherein the client can access a therapist from anywhere, at a convenient time while maintaining privacy and confidentiality. The process is non-threatening and clients can express themselves comfortably.",
    },
    {
      id: 13,
      question: "What is the duration of one therapy session?",
      answer:
        "A standard individual session with the Bit Happier Mental Wellness professional is 45 minutes long.",
    },
    {
      id: 14,
      question: "Does what we talk about in therapy remain confidential?",
      answer:
        "Confidentiality is one of the most important components in therapy, as successful therapy requires a high degree of trust. With few exceptions, the highly sensitive material that is discussed between you and your therapist will not be shared with anyone else without your permission. Exceptions to confidentiality will be shared with you in the informed consent form presented before therapy begins.",
    },
  ];

  const Platform = [
    {
      id: 1,
      question: "What does Bit Happier do?",
      answer:
        "Bit Happier is a decentralised platform bringing neuroscience, social networking, and financial tools together to assist everyone in achieving greater happiness. We generate personalised data-driven recommendations that help make small changes that can have a significant impact on one’s happiness.",
    },
    {
      id: 2,
      question: "What is a BHP- Bit Happier point?",
      answer:
        "The human brain works better when rewarded. Thus, we developed the Bit Happier Point, our inbuilt reward system that is given to you when you perform a recommended activity .",
    },
    {
      id: 3,
      question: "Is BHP actual money?",
      answer:
        "While Bit Happier Point is not actual money, it can be redeemed for monetary rewards such as mental wellness therapy sessions, digital art etc.",
    },
    {
      id: 4,
      question: "What kind of recommendations will be provided?",
      answer:
        "On the basis of your activity data, sleep data, brain health and stress levels, we analyse your lifestyle and recommend scientifically sound and research validated happiness solutions.",
    },
    {
      id: 5,
      question:
        "I don’t understand cryptocurrency much, will I be able to understand the process?",
      answer:
        "To ensure a seamless process for you, the digital wallet has been streamlined and the technology interface has been kept simple and easy to understand. For any questions, you can reach out to our team at contact@bithappier.com.",
    },
    {
      id: 6,
      question: "Will my data be protected?",
      answer:
        "Yes. Bit Happier adheres to the General Data Protection Regulation (GDPR) and The Health Insurance Portability and Accountability Act (HIPAA). These acts and regulations are standards for sensitive patient data protection for organisations. ",
    },
    {
      id: 7,
      question:
        "Do I have to provide my personal information to be a part of the platform?",
      answer:
        "Standard information such as your name and email address are required for you to create your digital wallet. Further, your health data can be uploaded on the platform upon your discretion. The information asked for helps us make well informed decisions to provide the best recommendations for you.",
    },
    {
      id: 8,
      question: "How can I purchase the art pieces on the website?",
      answer:
        "By using your digital wallet not only can you purchase Bit Happier’s Digital Art but also hold the intellectual property right of the chosen art piece.",
    },
    {
      id: 9,
      question:
        "Is there something wrong with me if my Happiness score is low?",
      answer:
        "No! At Bit Happier we aim to help you create positive habits by making small yet consistent changes that improve your overall well-being. These recommendations are decided upon through collaboration of a distinguished group of clinicians to not let you stray from your path of happiness.",
    },
  ];

  const researcher = [
    {
      id: 1,
      question: "What kind of research is Bit Happier doing?",
      answer:
        "Bit Happier in its research uses several different methodologies to capture brain structure and function. Using qEEG, Universal Thermo Scanner, Polycontrast Interference Photography and Extrasensory Perception.",
    },
    {
      id: 2,
      question: "What does an qEEG do?",
      answer:
        "A qualitative encephalogram (qEEG) can be used in determining which areas of the brain are engaged and processing efficiently. It  involves having a cap placed on the head that contains sensors that will read the electrical output of your brain. The results from a qEEG are useful in guiding various forms of treatment, including neurofeedback, biofeedback, diet, medication and lifestyle interventions.",
    },
    {
      id: 3,
      question: "What benefits will I be able to achieve from the research?",
      answer:
        "The research at Bit Happier aims to work towards providing scientifically sound happiness recommendations which are collaborated upon by a distinguished group of academicians and researchers.",
    },
  ];

  const tutorialsIndividuals = [
    {
      id: "1",
      name: "Exploring the Bit Happier Marketplace 🌟",
      link: "https://www.youtube.com/watch?v=BD6uwg6Ar8M",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "2",
      name: "How to Buy Bit Happier Tokens",
      link: "https://www.youtube.com/watch?v=H7YThHUl3GA",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "3",
      name: "Understanding the Bit Happier Points Wallet",
      link: "https://www.youtube.com/watch?v=Zi9i5oP1aZU",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "4",
      name: "Bit Happier marketplace",
      link: "https://www.youtube.com/watch?v=T0cgT3lU-Cs",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "5",
      name: "Bit Happier points wallet",
      link: "https://www.youtube.com/watch?v=obmG0TIgqSg",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "6",
      name: "Buying Bit Happier currency",
      link: "https://www.youtube.com/watch?v=_SNoLHpXXpg",
      buttonName: "Watch Tutorial",
      image: expert,
    },
  ];
  const tutorialsCorporates = [
    {
      id: "1",
      name: "Happiness Dashboard and Additional Pages",
      link: "https://www.youtube.com/watch?v=bDLbScgpLpo",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "2",
      name: "FIAT Wallet Overview",
      link: "https://www.youtube.com/watch?v=OozMQBlcudo",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "3",
      name: "Create and View Happiness Goals",
      link: "https://www.youtube.com/watch?v=1CwSaqvv9mQ",
      buttonName: "Watch Tutorial",
      image: expert,
    },
    {
      id: "4",
      name: "Happiness Buddy",  // AI Chatbot
      link: "https://www.youtube.com/watch?v=D_NBe3h3bwc",
      buttonName: "Watch Tutorial",
      image: expert,
    },
  ];

  const cookies = new Cookies();
  const token = cookies.get("isLoggedIn", { path: "/" });
  const roleType = DecodingString(cookies.get("_ssUuId", { path: "/" }));

  useEffect(() => {
    document.title = "FAQs | Bit Happier";
    const hash = window.location.hash;
    if (roleType && roleType === "ROLE_CORPORATE") {
      setTutorials(tutorialsCorporates);
    } else {
      setTutorials(tutorialsIndividuals);
    }
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    }
  }, []);
  return (
    <>
      <section style={{ background: "#fff5f7" }}>
        <header>
          {token ? (
            <>
              {roleType === "ROLE_USER" || roleType === "ROLE_CORPORATE" ? (
                <DashboardHeader />
              ) : (
                <ProfessionalHeader />
              )}
            </>
          ) : (
            <HomepageHeader />
          )}
        </header>
        <main style={{ paddingTop: '4rem' }}>
          <span
            onClick={() => {
              navigate(-1);
            }}
            style={{ cursor: "pointer", marginLeft: "1.5rem", marginTop: '1.5rem' }}
          >
            <span
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "18px",
                color: "#201f24",
              }}
            >
              <img className="me-1" src={back} alt="" width={20} />
              Back
            </span>
          </span>
          <div className="container my-5">

            {/* contact us  */}
            <div id="contactus">
              <div
                className="d-flex flex-column faq-sec-contact-us"
                style={{ paddingTop: "1rem" }}
              >
                <h6 className="pb-3">Contact us</h6>
                <p>Have any queries, questions or clarifications?</p>
                <p>
                  Reach out to us at{" "}
                  <a href="mailto:contact@bithappier.com">
                    contact@bithappier.com
                  </a>
                </p>
                <p>
                  Follow us on our social media handles to know more about Bit
                  Happier's regular updates.{" "}
                </p>
              </div>
            </div>
          </div>
        </main>
        <footer>
          <FooterHome />
          <FooterHomeStripe />
        </footer>
      </section>
    </>
  );
};

export default ContactUs;
